import {
  FETCH_EMPLOYMENT_REQUEST,
  FETCH_EMPLOYMENT_SUCCESS,
  FETCH_EMPLOYMENT_FAILURE,

  CREATE_EMPLOYMENT_REQUEST,
  CREATE_EMPLOYMENT_SUCCESS,
  CREATE_EMPLOYMENT_FAIL,
  CREATE_EMPLOYMENT_RESET,

  DELETE_EMPLOYMENT_REQUEST,
  DELETE_EMPLOYMENT_SUCCESS,
  DELETE_EMPLOYMENT_FAIL,
  DELETE_EMPLOYMENT_RESET,

  UPDATE_EMPLOYMENT_REQUEST,
  UPDATE_EMPLOYMENT_SUCCESS,
  UPDATE_EMPLOYMENT_FAIL,
  UPDATE_EMPLOYMENT_RESET
} from '../constants/employmentConstants';

const initialState = {
  loading: false,
  employments: [],
  error: null

};

export const employmentCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_EMPLOYMENT_REQUEST:
      return { loading: true };
    case CREATE_EMPLOYMENT_SUCCESS:
      return { loading: false, success: true };
    case CREATE_EMPLOYMENT_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_EMPLOYMENT_RESET:
      return {};
    default:
      return state;
  }
};

export const employmentListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_EMPLOYMENT_SUCCESS:
      return { ...state, loading: false, employments: action.payload };
    case FETCH_EMPLOYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const employmentDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_EMPLOYMENT_REQUEST:
      return { loading: true };
    case DELETE_EMPLOYMENT_SUCCESS:
      return { loading: false, success: true };
    case DELETE_EMPLOYMENT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_EMPLOYMENT_RESET:
      return {};
    default:
      return state;
  }
};

export const employmentUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_EMPLOYMENT_REQUEST:
      return { loading: true };
    case UPDATE_EMPLOYMENT_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_EMPLOYMENT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_EMPLOYMENT_RESET:
      return {};
    default:
      return state;
  }
};